export const CHUNHUIZK_CORPID = "wwd19fd071e0843b21"